























































import CostCardDocuments from "@/components/cost/CostCardDocuments.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval, ClearanceApproval } from "@/models/clearance-approval.entity";
import { ISignDocument } from "@/models/sign-document.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LineItemsForm from "../repair-estimate/LineItemsForm.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";

@Component({
  components: {
    LineItemsForm,
    CostCardDocuments,
    ConfirmActionDialog
  },
  filters: {}
})
export default class ClearanceApprovalDetailAddResponse extends mixins(RulesMixin) {
  readonly CurrencyEnum = CurrencyEnum;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  @Prop()
  value!: IClearanceApproval;

  valueCopy = new ClearanceApproval({ id: this.value.id, partnerId: this.value.partnerId });

  isDialogActive = false;

  isConfirmLoading = false;

  isValid = false;

  get documentIds() {
    return this.valueCopy.documentId ? [this.valueCopy.documentId] : [];
  }

  set documentIds(documentIds: string[]) {
    this.valueCopy.documentId = documentIds[documentIds.length - 1];
    if (!this.value.isCompleted) {
      // if clearance approval has not been completed, the user is prompted to add positions as well
      this.open();
    } else {
      // if clearance approval has been completed, we only update the documentId, because the positions were already set in the request
      this.updateDocumentId();
    }
  }

  async updateDocumentId() {
    try {
      this.isConfirmLoading = true;

      await this.value.updatePartial({
        documentId: this.valueCopy.documentId
      });
      this.$emit("change", this.value.documentId);
    } catch (e) {
      handleError(e);
    } finally {
      this.isConfirmLoading = false;
    }
  }

  async onCreatedDocument(...documents: ISignDocument[]) {
    this.$log.debug(documents);

    if (!this.valueCopy.title && documents.length) {
      const title = documents
        .map(d => {
          if (d.title?.endsWith(".pdf")) {
            return d.title.substring(0, d.title.length - 4);
          }
          return d.title;
        })
        .join("; ") as string;

      if (!this.valueCopy.title) {
        this.valueCopy.title = title;
      }
    }
  }

  open() {
    this.isDialogActive = true;
    this.valueCopy = new ClearanceApproval(this.value);
    if (!this.valueCopy.lineItems?.length) {
      this.valueCopy.lineItems = [new InvoiceLine({ title: "Position" })];
    }
  }

  cancel() {
    this.isDialogActive = false;
    this.valueCopy.documentId = "";

    // hack to reset the file input
    this.$nextTick(() => {
      this.valueCopy.documentId = undefined;
    });
  }

  async confirm() {
    try {
      this.isConfirmLoading = true;

      await this.value.updatePartial({
        documentId: this.valueCopy.documentId,
        title: this.valueCopy.title,
        currency: this.valueCopy.currency,
        status: this.valueCopy.lineItems.length && this.valueCopy.documentId ? RequestStatusEnum.REPLIED : undefined,
        lineItems: this.valueCopy.lineItems.map(li => li.dto)
      });
      this.isDialogActive = false;
      this.$emit("change", this.value.documentId);
    } catch (e) {
      handleError(e);
    } finally {
      this.isConfirmLoading = false;
    }
  }
}
